import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Button } from '@ff-os/shared-react/components/buttons/button/Button';
import { Link } from '@ff-os/shared-react/components/link/Link';
import { Heading } from '@ff-os/shared-react/components/panel/Heading';
import { Panel } from '@ff-os/shared-react/components/panel/Panel';
import { PhotoPrintsPdpDispatch, PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import classNames from 'classnames';
import { selectCanRemoveGroup } from '../../../_redux-groups';
import { removeGroup } from '../../../thunks/removeGroup';
import styles from './PhotoPrintsGroupPreview.module.scss';

const _EmptyPhotoPrintsGroupPreview = ({ start, remove, canRemove, className }: Props) => {
    const { t } = useTranslation();
    return (
        <Panel className={classNames(className, styles.container)} onClick={start}>
            <Heading icon='shopping-cart'>
                {t('photo_prints.empty_group')}
            </Heading>

            <p className={styles.noPhotos}>{t('photo_prints.no_photos')}</p>

            <Button className={styles.upload}>
                {t('commons.start')}
            </Button>

            {canRemove && (
                <Link
                    className={styles.remove}
                    onClick={remove}
                    style='danger' icon='general-ui-bin' />
            )}
        </Panel>
    );
};

type OwnProps = {
    start: () => void;
    groupId: string;
    className?: string;
};

type Props = OwnProps & {
    canRemove: boolean;
    remove: () => void;
};

const mapStateToProps = (state: PhotoPrintsPdpState, ownProps: OwnProps) => ({
    canRemove: selectCanRemoveGroup(state, ownProps.groupId)
});

const mapDispatchToProps = (dispatch: PhotoPrintsPdpDispatch, ownProps: OwnProps) => ({
    remove: () => dispatch(removeGroup(ownProps.groupId))
});

export const EmptyPhotoPrintsGroupPreview = connect(
    mapStateToProps,
    mapDispatchToProps
)(_EmptyPhotoPrintsGroupPreview);